import {Request} from "../core/request";
import {AuthHeader} from "../core/token";
import {SetCurrentUser} from "./auths";

export interface currentUserData {
    ID: number;               // GORM Model 的 ID 字段
    createdAt: string;        // GORM Model 的 CreatedAt 字段
    updatedAt: string;        // GORM Model 的 UpdatedAt 字段
    deletedAt?: string | null; // GORM Model 的 DeletedAt 字段（可选）

    name: string;             // 用户名，唯一
    email: string;            // 用户邮箱，唯一
    uuid: string;

    remark_name: string; // 备注名

    auth: number;               // 权限等级（admin 或 user）
    password: string;         // 密码（不返回）
    initPassword: string;     // 初始密码（不返回）
    ban: boolean;             // 是否封禁
    sumPasswordWrong: number; // 累计密码错误次数（不返回）
    passwordLockTime?: string | null; // 密码锁定时间（可选）
    loginTime: string;        // 上次登录时间

    sign?: string | null;     // 用户签名（可选）
    avatar?: string | null;   // 用户头像（可选）
    resignation?: boolean;
    resignationTime?: string;
    markResignation?: boolean;
    markResignationTime?: string;
}

export async function currentUser(): Promise<{ data: currentUserData }> {
    const resp = await Request.get<currentUserData>('/auth/currentUser', {headers: AuthHeader()});

    SetCurrentUser(resp.data || undefined);
    return resp
}

export async function updateDetail(name: string) {
    return await Request.post(`/auth/currentUser/updateName`, {
        name: name,
    }, {headers: AuthHeader()});
}

export async function updateAvatar(data: string) {
    return await Request.post(`/auth/currentUser/updateAvatar`, {
        data: data,
    }, {headers: AuthHeader()});
}

export async function getAllUsers() {
    return await Request.get("/academics/users/", {headers: AuthHeader()});
}

export async function getAllAcademicsUsers() {
    return await Request.get("/academics/users/academics", {headers: AuthHeader()});
}

export async function updateUserAuth(user: number, auth: number, set: boolean) {
    return await Request.post(`/super_admin/update_auth`, {
        user_id: user, auth: auth, set: set
    }, {headers: AuthHeader()})
}

export async function updateUserMarkName(user: number, newName: string) {
    return await Request.post(`/super_admin/mark_name`, {
        user_id: user, mark_name: newName,
    }, {headers: AuthHeader()});
}
